var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.333 15.832a.834.834 0 0 1-.64-1.367l3.73-4.475-3.596-4.468a.834.834 0 0 1 1.3-1.045l4.023 5c.248.309.245.75-.01 1.056l-4.166 5a.833.833 0 0 1-.641.3Z",
    fill: "#008545"
  })));
};
export default SvgChevronRight;